import React from "react";
import Backdrop from "../../../../UI/Backdrop";

const DeleteAccountModal = ({ onConfirm, onCancel }) => {
  return (
    <>
      <Backdrop />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[9999] min-w-[450px] bg-white rounded-[15px] px-5 py-8">
        <h2 className="font-ubuntu text-center font-bold mb-4">
          Your account deletion request will be processed in 30 days.
        </h2>

        <p className="text-sm text-center">
          If you login again before this period ends, the request will be cancelled.
          After 30 days, your account and data will be permanently deleted.
        </p>

        <div className="flex space-x-5 justify-center mt-8">
          <button
            onClick={onConfirm}
            className="px-4 bg-[#FFDBB0] text-[#F77611] font-ubuntu font-bold py-2 rounded-full min-w-[120px]"
          >
            Confirm Delete
          </button>

          <button
            onClick={onCancel}
            className="px-4 bg-[#FFDBB0] text-[#F77611] font-ubuntu font-bold py-2 rounded-full min-w-[120px]"
          >
            Cancel
          </button>
        </div>
      </div>
    </>
  );
};

export default DeleteAccountModal;

